import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  size: 'full',
  path: 'payroll-management',
  children: {
    noPolicies: {
      size: 'full',
      path: 'no-policies',
    },
    setup: {
      size: 'full',
      path: 'setup',
    },
    results: {
      path: 'results',
      size: 'full',
    },
    supplements: {
      size: 'full',
      path: 'supplements',
      children: {
        export: {
          size: 'full',
          path: 'export',
        },
      },
    },
    sepa: {
      size: 'full',
      path: 'sepa',
    },
    incidences: {
      size: 'full',
      path: 'incidences',
      children: {
        id: {
          size: 'full',
          path: ':id',
        },
        idChanges: {
          size: 'full',
          path: ':id/changes',
        },
        idMessages: {
          size: 'full',
          path: ':id/messages',
        },
        idAll: {
          size: 'full',
          path: ':id/*',
        },
        idNotes: {
          size: 'full',
          path: ':id/notes',
        },
      },
    },
    incidencesLanding: {
      size: 'full',
      path: 'incidences-landing',
    },
    inhouseActivation: {
      size: 'full',
      path: 'inhouse-activation',
    },
    policy: {
      path: 'policies/:policyId',
      size: 'full',
      children: {
        dashboard: {
          size: 'full',
          path: 'dashboard',
        },
        issues: {
          size: 'full',
          path: 'issues',
        },
        supplements: {
          size: 'full',
          path: 'supplements',
        },
        period: {
          path: 'periods/:periodId',
          size: 'full',
          children: {
            dashboard: {
              size: 'full',
              path: 'dashboard',
            },
            issues: {
              size: 'full',
              path: 'issues',
            },
            results: {
              size: 'full',
              path: 'results',
            },
            cycles: {
              size: 'full',
              path: 'cycles',
              children: {
                results: {
                  size: 'full',
                  path: 'results',
                  children: {
                    import: {
                      size: 'full',
                      path: 'import',
                    },
                  },
                },
                supplements: {
                  size: 'full',
                  path: 'supplements',
                  children: {
                    export: {
                      size: 'full',
                      path: 'export',
                    },
                    import: {
                      size: 'full',
                      path: 'import',
                    },
                  },
                },
                payments: {
                  size: 'full',
                  path: 'payments',
                  children: {
                    generate: {
                      size: 'full',
                      path: 'generate',
                    },
                  },
                },
              },
            },
            offcycles: {
              size: 'full',
              path: 'offcycles',
              children: {
                results: {
                  size: 'full',
                  path: 'results',
                  children: {
                    import: {
                      size: 'full',
                      path: 'import',
                    },
                  },
                },
                payments: {
                  size: 'full',
                  path: 'payments',
                  children: {
                    generate: {
                      size: 'full',
                      path: 'generate',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
} as const satisfies Location
